/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_use_8 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comply with legal obligations`)
};

const es_privacy_use_8 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cumplir con obligaciones legales`)
};

const de_privacy_use_8 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesetzlichen Verpflichtungen nachzukommen`)
};

const nl_privacy_use_8 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aan wettelijke verplichtingen te voldoen`)
};

const fr_privacy_use_8 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respecter les obligations légales`)
};

const it_privacy_use_8 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adempiere agli obblighi di legge`)
};

const pt_br2_privacy_use_8 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cumprir obrigações legais`)
};

const pt_privacy_use_8 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cumprir obrigações legais`)
};

const ja_privacy_use_8 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`法的義務の遵守`)
};

const zh_privacy_use_8 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`遵守法律义务`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_use_8 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_use_8(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_use_8", locale)
	if (locale === "en") return en_privacy_use_8(inputs)
	if (locale === "es") return es_privacy_use_8(inputs)
	if (locale === "de") return de_privacy_use_8(inputs)
	if (locale === "nl") return nl_privacy_use_8(inputs)
	if (locale === "fr") return fr_privacy_use_8(inputs)
	if (locale === "it") return it_privacy_use_8(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_use_8(inputs)
	if (locale === "pt") return pt_privacy_use_8(inputs)
	if (locale === "ja") return ja_privacy_use_8(inputs)
	return zh_privacy_use_8(inputs)
};